import DocumentExportFormDatevView from './document-export-form-datev-view'

export default {
  box: DocumentExportFormDatevView,
}
